/*
	GETTERS
*/
//------------------------------------------------------------
// GET WINDOWS
//------------------------------------------------------------

const getWindows = (state) => {
	return state.openWindows;
}

//------------------------------------------------------------
// GET WINDOW BY UID
//------------------------------------------------------------

const getWindowByUid = (state) => (uid) => {
	const windows = state.openWindows;

    for (let i = 0; i < windows.length; i++) {
		if (windows[i].uid === uid) {
			return { panel: windows[i], index: i }; // return panel with id (for z-index)
		}
	}
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	getWindows,
	getWindowByUid
}
//===========================================
//
//===========================================